<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目ID：" prop="pid1">
                <span>{{model.pid1}}</span>
            </el-form-item>
            <el-form-item label="出厂编号：" prop="factory_code">
                <span>{{model.factory_code}}</span>
            </el-form-item>
            <el-form-item label="品牌：" prop="brand">
                <span>{{model.brand}}</span>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="物联网卡ID：" prop="net_card_id">
                <span>{{model.net_card_id}}</span>
            </el-form-item>
            <el-form-item label="物联网卡号：" prop="net_card_code">
                <span>{{model.net_card_code}}</span>
            </el-form-item>
            <el-form-item label="运营商：" prop="operator">
                <span>{{model.operator}}</span>
            </el-form-item>
            <el-form-item label="启用状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="添加人ID：" prop="creator_id">
                <span>{{model.creator_id}}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人ID：" prop="update_id">
                <span>{{model.update_id}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'routersInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                factory_code: '',
                brand: '',
                device_code: '',
                net_card_id: '',
                net_card_code: '',
                state: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/routers/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>